export const POWER_BI_NODE_COLOR = '#EAB308';

export const getNodeColor = (
  type,
  status,
  isDataPulseProduct = true,
  isPowerBIReport = false,
) => {
  if (isPowerBIReport) {
    return POWER_BI_NODE_COLOR;
  }

  if (isDataPulseProduct === false) {
    return '#9CA3AF';
  }

  switch (status) {
    case 'healthy':
      return '#10B981';
    case 'warning':
      return 'orange';
    case 'critical':
      return '#EF4444';
    case 'na':
    case 'n/a':
      return '#9CA3AF';
    default:
      return '#EF4444';
  }
};

export const getDisplayLabel = (name, maxLength) => {
  const value = String(name || '');
  if (value.length <= maxLength) {
    return value;
  }

  return `${value.slice(0, maxLength)}...`;
};